import AuthGuard from '@components/AuthGuard';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useUser from '@hooks/auth/useUser';
import useInquiryInfo from '@hooks/inquiry/useInquiryInfo';
import ArrowLineRight from '@icons/arrow/ArrowLineRight';
import BarcodeIcon from '@icons/BarcodeIcon';
import CsIcon from '@icons/CsIcon';
import SettingIcon from '@icons/SettingIcon';
import { Link } from '@router/Link';
import { useFlow } from '@router/stackflow';
import { isSidebarOpenAtom } from '@states/uiAtoms';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import SidebarButton from './SidebarButton';
import UserInfo from './UserInfo';

function SidebarHeader() {
    const { user } = useUser();
    const setSidebar = useSetAtom(isSidebarOpenAtom);
    const closeSidebar = () => setSidebar(false);
    const { push } = useFlow();
    const { inquiryEnabled } = useInquiryInfo();
    const { t } = useTranslation('main', { keyPrefix: 'sidebar' });
    return (
        <Container>
            <Row fullWidth justify='space-between' spacing={20}>
                <UserInfo/>
                <Text onClick={closeSidebar}>
                    {t('close')}
                </Text>
            </Row>
            <Row spacing={8} align='stretch'>
                <AuthGuard>
                    <SidebarButton label={t('membershipBarcode')}
                        icon={BarcodeIcon}
                        onClick={() => push('BarcodeModal', {})} />
                </AuthGuard>
                {inquiryEnabled && (
                    <AuthGuard>
                        <SidebarButton label={t('serviceCenter')}
                            icon={CsIcon}
                            onClick={() => push('CustomerServiceActivity', { type: 'BRAND' })} />
                    </AuthGuard>
                )}
                <Wrapper>
                    <SidebarButton label={t('accountSetting')}
                        icon={SettingIcon}
                        onClick={() => push('AccountSettingActivity', {})} />
                </Wrapper>
            </Row>
        </Container>
    );
}

const Container = styled.div`
    padding: calc(64px +  var(--safe-area-top)) 16px 24px;
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 32px;
`;

const Wrapper = styled.div`
    width: 100%;
`;

export default SidebarHeader;
